<template>
    <div class="gp-app-video">
        <img v-show="posterVisible || !(videoVisible && $root.$data.videoView[index])" :src="poster" class="gp-app-video__poster">
        <video
            id="video_one"
            ref="video"
            class="gp-app-video__video"
            :class="{'is-visible': videoVisible && $root.$data.videoView[index], 
                     'is-visible-v': videoVisible && $root.$data.videoView[index] && isV}"
            :src="src"
            muted
        ></video>
        <div class="gp-app-video__control">
            <div v-if="paused || !$root.$data.videoView[index]" class="gp-app-video__play-area" @click="showAndPlay(true)">
                <div class="gp-app-video__play-btn"></div>
                <div class="gp-app-video__play-duration">{{ duration }}</div>
            </div>
            <div v-else class="gp-app-video__control-bar">
                <div class="gp-app-video__pause-btn" @click="pause(true)"></div>
                <div class="gp-app-video__mute" :class="{'is-muted': muted}" @click="toggleMute"></div>
            </div>
        </div>
    </div>
</template>
<script>
    import { on } from '@/utils/dom';
    import {isIOS} from '@/utils/browser';
    import {getQueryString} from '@/utils/url';
    export default {
        props: {
            poster: {
                type: String,
                required: true
            },
            src: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            isV: {
                type: Boolean,
                required: false
            },
            tab: {
                type: String,
                required: false
            },
            item: {
                type: Object,
                required: false
            },
            tabName: {
                type: String,
                required: false
            },
            moduleName: {
                type: String,
                required: false,
                default: ''
            },
            source: {
                type: Number,
                required: false,
            },
            duration: {
                type: String,
                require: false
            },
            h5: {
                type: String,
                require: false
            }
        },
        data() {
            return {
                posterVisible: true,
                paused: true,
                videoVisible: false,
                muted: false,
                lastStatus: {
                    paused: true,
                    videoVisible: false
                }
            }
        },
        mounted() {
            on(this.$refs.video, 'ended', () => {
                this.paused = true;
                this.$parent.playEnd = true;
                this.$parent.doClickLog('playFinish', {
                    answerId: this.$parent.answerId,
                    contentFrom: getQueryString('source') || '',
                    playFinish: 'yes' 
                })
            });
            on(this.$refs.video, 'pause', () => {
                this.paused = true;
                if (isIOS()) {
                    this.videoVisible = false;
                }
            });
        },
        destroyed() {
            this.$root.$data.videoView = [];
        },
        methods: {
            logPush(clk) {
                let content = {
                    value: 'video',
                    ext: {
                        id: '',
                        ext: Object.assign({
                            clickState: clk ? "play" : "pause",
                            answerId: getQueryString('answer_id') ? getQueryString('answer_id') : getQueryString('cid'),
                            contentFrom: getQueryString('source') || ''
                        }, this.$root.extData),
                        pos: ''
                    }
                }
                this.$logger.click(content);
            },
            showAndPlay() {
                if (this.source === 0) return;
                this.logPush(true);
                if (this.source !== 13) {
                    location.href = this.h5;
                    return;
                }
                this.$root.$data.videoView = [];
                this.$root.$data.videoView[this.index] = true;
                this.show();
                this.play();
            },
            play() {
                this.$refs.video.play();
                this.muted = this.$refs.video.muted;
                this.posterVisible = false;
                this.paused = false;
            },
            pause() {
                this.logPush(false);
                this.lastStatus.paused = this.paused;
                this.lastStatus.videoVisible = this.videoVisible;
                this.$refs.video.pause();
                this.paused = true;
            },
            toggleMute() {
                this.$refs.video.muted = !this.$refs.video.muted;
                this.muted = this.$refs.video.muted;
            },
            show() {
                this.videoVisible = true;
            },
            hide() {
                this.videoVisible = false;
            },
            restore() {
                if (!this.lastStatus.paused) {
                    this.play();
                }
                if (this.lastStatus.videoVisible) {
                    this.show();
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "~@/common/style/mixin/utils";
    @import "~@/common/style/mixin/mixins";
    $design-width: 1242;

    @include b(app-video) {
        width: 100%;
        height: 100%;
        position: relative;
        border-radius: px2rem(39);
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #000;
        overflow: hidden;

        @include e(poster) {
            width: 100%;
            height: 100%;
        }

        @include e(video) {
            width: 0px;
            height: 0px;
            object-fit: fill;

            @include when(visible) {
                width: auto;
                height: 100%;
            }

            @include when(visible-v) {
                width: 100%;
                height: auto;
            }
        }

        @include e(control) {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            border-bottom-left-radius: px2rem(39);
            border-bottom-right-radius: px2rem(39);
        }
        @include e(play-area) {
            width: 100%;
            height: 100%;
        }
        @include e(play-btn) {
            width: px2rem(140);
            height: px2rem(140);
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: url('~public/assets/imgs/play.png') no-repeat;
            background-size: contain;
        }
        @include e(play-duration) {
            font-size: px2rem(36);
            color: #fff;
            position: absolute;
            right: px2rem(24);
            bottom: px2rem(26);
        }

        @include e(control-bar) {
            width: 100%;
            height: px2rem(80);
            background: rgba(0, 0, 0, 0.2);
            position: absolute;
            bottom: 0;
            left: 0;
            display: flex;
            align-items: center;
            border-bottom-left-radius: px2rem(39);
            border-bottom-right-radius: px2rem(39);
        }

        @include e(pause-btn) {
            width: px2rem(50);
            height: px2rem(40);
            margin: 0 px2rem(15) 0 px2rem(30);
            background: url('~public/assets/imgs/pause.png') no-repeat;
            background-size: cover;
        }

        @include e(mute) {
            width: px2rem(50);
            height: px2rem(50);
            margin: 0 px2rem(15);
            background: url('~public/assets/imgs/voice.png') no-repeat;
            background-size: cover;

            @include when(muted) {
                background: url('~public/assets/imgs/mute.png') no-repeat;
                background-size: cover;
            }
        }
    }

</style>
